class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this._hoverCloseTimer = null;
    this._hoverMedia = window.matchMedia?.('(hover: hover) and (pointer: fine)');
    this._closeAnimTimer = null;

    this.mainDetailsToggle?.addEventListener('mouseenter', this.onMouseEnter?.bind(this));
    this.mainDetailsToggle?.addEventListener('mouseleave', this.onMouseLeave?.bind(this));

    const summary = this.mainDetailsToggle?.querySelector('summary');
    summary?.addEventListener('click', (event) => {
      const linkEl = event?.target?.closest?.('[data-header-menu-link]');

      if (linkEl) {
        if (this.isHoverMode()) return;
        event.preventDefault();
        event.stopPropagation();
        this.open();
        return;
      }

      if (!this.isHoverMode()) return;
      event.preventDefault();
      event.stopPropagation();
      this.open();
    });
  }

  isHoverMode() {
    return Boolean(this._hoverMedia?.matches) && window.innerWidth >= 990;
  }

  open() {
    if (!this.mainDetailsToggle) return;
    if (this._closeAnimTimer) window.clearTimeout(this._closeAnimTimer);
    this._closeAnimTimer = null;
    this.mainDetailsToggle.classList.remove('is-closing');

    if (this.mainDetailsToggle.open) return;

    document.querySelectorAll('header-menu').forEach((el) => {
      if (el !== this && typeof el.close === 'function') el.close();
    });

    if (this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }

    const summary = this.mainDetailsToggle.querySelector('summary');
    summary?.setAttribute('aria-expanded', true);
    this.mainDetailsToggle.open = true;
  }

  close() {
    if (!this.mainDetailsToggle) return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    const summary = this.mainDetailsToggle.querySelector('summary');
    summary?.setAttribute('aria-expanded', false);

    this.mainDetailsToggle.classList.add('is-closing');

    if (this._closeAnimTimer) window.clearTimeout(this._closeAnimTimer);
    this._closeAnimTimer = window.setTimeout(() => {
      this.mainDetailsToggle.classList.remove('is-closing');
      this.mainDetailsToggle.removeAttribute('open');
      this._closeAnimTimer = null;
    }, 240);
  }

  onMouseEnter() {
    if (!this.isHoverMode()) return;
    if (this._hoverCloseTimer) window.clearTimeout(this._hoverCloseTimer);
    this._hoverCloseTimer = null;
    this.open();
  }

  onMouseLeave() {
    if (!this.isHoverMode()) return;
    if (this._hoverCloseTimer) window.clearTimeout(this._hoverCloseTimer);
    this._hoverCloseTimer = window.setTimeout(() => {
      this.close();
    }, 120);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
